import React, { useEffect, useMemo, useState } from "react";
import { Card } from "primereact/card";
import CustomeButton from "~/components/Button";
import PayslipApproveListTable from "./PayslipApproveListTable";
import { useSelector } from "react-redux";
import { Skeleton } from "primereact/skeleton";
import ToastMessage from "~/components/ToastMessage";

interface TaskData {
  name?: string;
  owner?: string;
}

interface Milestone {
  taskData?: TaskData[];
}

const PayslipApproveCard = ({
  process,
  data = [],
  loading,
  onApprove,
  tasksdata,
  isApproveLoading,
  employeesData,
  isApproveButtonEnable,
  fetchEmployees,
  setIsTaskCommentModal,
  setSelectedTask,
  setIsRejectPayslip,
  errorToastRef,
}) => {
  const filteredData = useMemo(
    () =>
      data.filter(
        (d) => d?.match_status !== "rejected" && d?.match_status !== "source",
      ),
    [data],
  );
  useEffect(() => {
    if (process?.entity) {
      fetchEmployees();
    }
  }, [process?.entity]);

  const [taskData, setTaskData] = useState<TaskData>({});
  const { processmilestones } = useSelector((state) => state.milestones);
  const { role } = useSelector((state) => state.login);
  const [isRejectVisible, setIsRejectVisible] = useState(false);

  useEffect(() => {
    const result =
      processmilestones
        .flatMap((milestone: Milestone) => milestone.taskData || [])
        .find((task: TaskData) => task.name === "Release of payslips") || null;

    if (result) {
      setTaskData(result);
    }
  }, [processmilestones]);

  const rejectPayslips = () => {
    setIsRejectPayslip(true);
    setSelectedTask(taskData);
    setIsTaskCommentModal(true);
  };

  useEffect(() => {
    if (taskData?.owner) {
      setIsRejectVisible(
        isApproveButtonEnable ||
          (["CUSTOMER", "CUSTOMER_MANAGER"].includes(role) &&
            taskData?.owner === "Customer"),
      );
    }
  }, [taskData, isApproveButtonEnable, role]);

  return (
    <Card className="mb-4 payslip-card p-5">
      <div className="payslip-card-content flex flex-column gap-1">
        <p className="card-title">Review Submitted Payslips for Approval</p>
        <p className="card-description">
          Please review the payslips submitted for this payroll cycle. Once
          verified, approve them to proceed with employee release.
        </p>
      </div>
      <div className="flex">
        {isRejectVisible &&
          (loading ? (
            <Skeleton width="11rem" height="3rem" className="ml-auto" />
          ) : (
            <CustomeButton
              label="Reject Payslips"
              iconPos="right"
              onClick={rejectPayslips}
            />
          ))}

        {loading ? (
          <Skeleton width="11rem" height="3rem" />
        ) : (
          <CustomeButton
            label="Approve & Release"
            className="ml-auto max-w-max"
            variant="contained"
            iconPos="right"
            loading={isApproveLoading}
            disabled={!isApproveButtonEnable || isApproveLoading}
            onClick={() => {
              onApprove(tasksdata);
            }}
          />
        )}
      </div>
      <PayslipApproveListTable
        data={filteredData}
        loading={loading}
        employeesData={employeesData}
      />
      <ToastMessage ref={errorToastRef} />
    </Card>
  );
};

export default PayslipApproveCard;
